import { OrderService } from 'services/order.service';
import {
  Inject,
  OnInit,
  Component, Input,
} from 'ng-metadata/core';

import trackOrderHtml from './track-order.html';
import './track-order.scss';

@Component({
  selector: 'gw-portal-track-order',
  template: trackOrderHtml,
})
export class TrackOrderComponent implements OnInit {
  public trackOrderForm;
  public orderNumber = '';
  public userEmail = '';
  public submitting = false;
  public success = null;
  public orderInfo = null;
  public errorMessage = '';

  @Input() portal;
  constructor(
    @Inject(OrderService) private orderService: OrderService,
  ) {}

  ngOnInit() {
  }

  async submitForm() {
    if (this.trackOrderForm.$invalid) {
      return;
    }

    this.submitting = true;
    this.errorMessage = '';
    this.orderService.trackOrder(this.userEmail, this.orderNumber, this.portal).then((response) => {
      this.orderInfo = response.data;
      this.clearForm(true);
    }).catch((error) => {
      this.errorMessage = error.message;
      this.clearForm(false);
    }).finally(() => {
      this.submitting = false;
    });
  }

  editing() {
    if (!this.submitting) {
      this.success = null;
    }
  }

  clearForm(success: boolean) {
    if (success) {
      this.orderNumber = '';
      this.userEmail = '';

      this.trackOrderForm.$setPristine();
      this.trackOrderForm.$setUntouched();
    }
    this.success = success;
  }

  clearResults() {
    this.orderInfo = null;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/track-order/track-order.component.ts